import { ICreditCondition } from '@r1-frontend/api-domru/payments/v1/credits/condition';

export const getSelectedCreditCondition = (creditConditions: ICreditCondition[], selectedOptionId: string | number): ICreditCondition | undefined => {
    if (!creditConditions.length || Number.isNaN(Number(selectedOptionId))) {
        return;
    }
    const [minCreditByDuration] = creditConditions.sort((a, b) => a.duration - b.duration);
    return creditConditions.find(item => item.duration === Number(selectedOptionId)) || minCreditByDuration;
};
